import adultHeartHigh from '#assets/images/gutBodyConnections/adult/heart-high.webp';
import adultHeartLow from '#assets/images/gutBodyConnections/adult/heart-low.webp';
import adultHeartModerate from '#assets/images/gutBodyConnections/adult/heart-moderate.webp';
import adultImmuneHigh from '#assets/images/gutBodyConnections/adult/immune-high.svg';
import adultImmuneLow from '#assets/images/gutBodyConnections/adult/immune-low.svg';
import adultImmuneModerate from '#assets/images/gutBodyConnections/adult/immune-moderate.svg';
import intestinesUterusFullHigh from '#assets/images/gutBodyConnections/adult/intestines-uterus-full-high.webp';
import intestinesUterusFullLow from '#assets/images/gutBodyConnections/adult/intestines-uterus-full-low.webp';
import intestinesUterusFullModerate from '#assets/images/gutBodyConnections/adult/intestines-uterus-full-moderate.webp';
import intestinesWithUterusHigh from '#assets/images/gutBodyConnections/adult/intestines-with-uterus-high.webp';
import intestinesWithUterusLow from '#assets/images/gutBodyConnections/adult/intestines-with-uterus-low.webp';
import intestinesWithUterusModerate from '#assets/images/gutBodyConnections/adult/intestines-with-uterus-moderate.webp';
import adultKidneyHigh from '#assets/images/gutBodyConnections/adult/kidney-high.webp';
import adultKidneyLow from '#assets/images/gutBodyConnections/adult/kidney-low.webp';
import adultKidneyModerate from '#assets/images/gutBodyConnections/adult/kidney-moderate.webp';
import adultLiverHigh from '#assets/images/gutBodyConnections/adult/liver-high.webp';
import adultLiverLow from '#assets/images/gutBodyConnections/adult/liver-low.webp';
import adultLiverModerate from '#assets/images/gutBodyConnections/adult/liver-moderate.webp';
import adultLungsHigh from '#assets/images/gutBodyConnections/adult/lungs-high.webp';
import adultLungsLow from '#assets/images/gutBodyConnections/adult/lungs-low.webp';
import adultLungsModerate from '#assets/images/gutBodyConnections/adult/lungs-moderate.webp';
import adultMetabolicHigh from '#assets/images/gutBodyConnections/adult/metabolic-high.svg';
import adultMetabolicLow from '#assets/images/gutBodyConnections/adult/metabolic-low.svg';
import adultMetabolicModerate from '#assets/images/gutBodyConnections/adult/metabolic-moderate.svg';
import adultMusculoskeletalHigh from '#assets/images/gutBodyConnections/adult/musculoskeletal-high.webp';
import adultMusculoskeletalLow from '#assets/images/gutBodyConnections/adult/musculoskeletal-low.webp';
import adultMusculoskeletalModerate from '#assets/images/gutBodyConnections/adult/musculoskeletal-moderate.webp';
import fetusHigh from '#assets/images/gutBodyConnections/adult/pregnant/fetus-high.webp';
import fetusLow from '#assets/images/gutBodyConnections/adult/pregnant/fetus-low.webp';
import fetusModerate from '#assets/images/gutBodyConnections/adult/pregnant/fetus-moderate.webp';
import intestinesBabyFullHigh from '#assets/images/gutBodyConnections/adult/pregnant/intestines-baby-full-high.webp';
import intestinesBabyFullLow from '#assets/images/gutBodyConnections/adult/pregnant/intestines-baby-full-low.webp';
import intestinesBabyFullModerate from '#assets/images/gutBodyConnections/adult/pregnant/intestines-baby-full-moderate.webp';
import intestinesWithBabyHigh from '#assets/images/gutBodyConnections/adult/pregnant/intestines-with-baby-high.webp';
import intestinesWithBabyLow from '#assets/images/gutBodyConnections/adult/pregnant/intestines-with-baby-low.webp';
import intestinesWithBabyModerate from '#assets/images/gutBodyConnections/adult/pregnant/intestines-with-baby-moderate.webp';
import adultThyroidHigh from '#assets/images/gutBodyConnections/adult/thyroid-high.webp';
import adultThyroidLow from '#assets/images/gutBodyConnections/adult/thyroid-low.webp';
import adultThyroidModerate from '#assets/images/gutBodyConnections/adult/thyroid-moderate.webp';
import uterusHigh from '#assets/images/gutBodyConnections/adult/uterus-high.webp';
import uterusLow from '#assets/images/gutBodyConnections/adult/uterus-low.webp';
import uterusModerate from '#assets/images/gutBodyConnections/adult/uterus-moderate.webp';
import babyToddlerImmuneHigh from '#assets/images/gutBodyConnections/baby-toddler/immune-high.svg';
import babyToddlerImmuneLow from '#assets/images/gutBodyConnections/baby-toddler/immune-low.svg';
import babyToddlerImmuneModerate from '#assets/images/gutBodyConnections/baby-toddler/immune-moderate.svg';
import childImmuneHigh from '#assets/images/gutBodyConnections/child/immune-high.svg';
import childImmuneLow from '#assets/images/gutBodyConnections/child/immune-low.svg';
import childImmuneModerate from '#assets/images/gutBodyConnections/child/immune-moderate.svg';
import paediatricLungsHigh from '#assets/images/gutBodyConnections/paediatric/lungs-high.webp';
import paediatricLungsLow from '#assets/images/gutBodyConnections/paediatric/lungs-low.webp';
import paediatricLungsModerate from '#assets/images/gutBodyConnections/paediatric/lungs-moderate.webp';
import brainHigh from '#assets/images/gutBodyConnections/shared/brain-high.webp';
import brainLow from '#assets/images/gutBodyConnections/shared/brain-low.webp';
import brainModerate from '#assets/images/gutBodyConnections/shared/brain-moderate.webp';
import intestinesFullHigh from '#assets/images/gutBodyConnections/shared/intestines-full-high.webp';
import intestinesFullLow from '#assets/images/gutBodyConnections/shared/intestines-full-low.webp';
import intestinesFullModerate from '#assets/images/gutBodyConnections/shared/intestines-full-moderate.webp';
import intestinesHigh from '#assets/images/gutBodyConnections/shared/intestines-high.webp';
import intestinesLow from '#assets/images/gutBodyConnections/shared/intestines-low.webp';
import intestinesModerate from '#assets/images/gutBodyConnections/shared/intestines-moderate.webp';
import skinHigh from '#assets/images/gutBodyConnections/shared/skin-high.svg';
import skinLow from '#assets/images/gutBodyConnections/shared/skin-low.svg';
import skinModerate from '#assets/images/gutBodyConnections/shared/skin-moderate.svg';
import stomachFullHigh from '#assets/images/gutBodyConnections/shared/stomach-full-high.webp';
import stomachFullLow from '#assets/images/gutBodyConnections/shared/stomach-full-low.webp';
import stomachFullModerate from '#assets/images/gutBodyConnections/shared/stomach-full-moderate.webp';
import stomachHigh from '#assets/images/gutBodyConnections/shared/stomach-high.webp';
import stomachLow from '#assets/images/gutBodyConnections/shared/stomach-low.webp';
import stomachModerate from '#assets/images/gutBodyConnections/shared/stomach-moderate.webp';

// Monochrome purple variants for the First Look intro. One per drawing, framed to
// match its flag-coloured siblings; organs without one fall back to the flag art.
import adultHeartPurple from '#assets/images/gutBodyConnections/adult/heart-purple.webp';
import adultImmunePurple from '#assets/images/gutBodyConnections/adult/immune-purple.svg';
import intestinesUterusFullPurple from '#assets/images/gutBodyConnections/adult/intestines-uterus-full-purple.webp';
import adultKidneyPurple from '#assets/images/gutBodyConnections/adult/kidney-purple.webp';
import adultLiverPurple from '#assets/images/gutBodyConnections/adult/liver-purple.webp';
import adultLungsPurple from '#assets/images/gutBodyConnections/adult/lungs-purple.webp';
import adultMetabolicPurple from '#assets/images/gutBodyConnections/adult/metabolic-purple.webp';
import adultMusculoskeletalPurple from '#assets/images/gutBodyConnections/adult/musculoskeletal-purple.webp';
import fetusPurple from '#assets/images/gutBodyConnections/adult/pregnant/fetus-purple.webp';
import intestinesBabyFullPurple from '#assets/images/gutBodyConnections/adult/pregnant/intestines-baby-full-purple.webp';
import adultThyroidPurple from '#assets/images/gutBodyConnections/adult/thyroid-purple.webp';
import uterusPurple from '#assets/images/gutBodyConnections/adult/uterus-purple.webp';
import babyToddlerImmunePurple from '#assets/images/gutBodyConnections/baby-toddler/immune-purple.svg';
import childImmunePurple from '#assets/images/gutBodyConnections/child/immune-purple.svg';
import paediatricLungsPurple from '#assets/images/gutBodyConnections/paediatric/lungs-purple.webp';
import brainPurple from '#assets/images/gutBodyConnections/shared/brain-purple.webp';
import intestinesFullPurple from '#assets/images/gutBodyConnections/shared/intestines-full-purple.webp';
import intestinesPurple from '#assets/images/gutBodyConnections/shared/intestines-purple.webp';
import skinPurple from '#assets/images/gutBodyConnections/shared/skin-purple.svg';
import stomachFullPurple from '#assets/images/gutBodyConnections/shared/stomach-full-purple.webp';
import stomachPurple from '#assets/images/gutBodyConnections/shared/stomach-purple.webp';

import type { GutBodyConnectionsArtwork, OrganArtworkSet } from './types';

/** The full-resolution drawings, sized for retina screens. */
export const HIGH_QUALITY_ARTWORK: OrganArtworkSet = {
  brain: {
    low: brainLow,
    moderate: brainModerate,
    high: brainHigh,
    purple: brainPurple,
  },
  skin: {
    low: skinLow,
    moderate: skinModerate,
    high: skinHigh,
    purple: skinPurple,
  },
  endocrine: {
    low: adultThyroidLow,
    moderate: adultThyroidModerate,
    high: adultThyroidHigh,
    purple: adultThyroidPurple,
  },
  heart: {
    low: adultHeartLow,
    moderate: adultHeartModerate,
    high: adultHeartHigh,
    purple: adultHeartPurple,
  },
  kidney: {
    low: adultKidneyLow,
    moderate: adultKidneyModerate,
    high: adultKidneyHigh,
    purple: adultKidneyPurple,
  },
  liver: {
    low: adultLiverLow,
    moderate: adultLiverModerate,
    high: adultLiverHigh,
    purple: adultLiverPurple,
  },
  metabolic: {
    low: adultMetabolicLow,
    moderate: adultMetabolicModerate,
    high: adultMetabolicHigh,
    purple: adultMetabolicPurple,
  },
  muscle: {
    low: adultMusculoskeletalLow,
    moderate: adultMusculoskeletalModerate,
    high: adultMusculoskeletalHigh,
    purple: adultMusculoskeletalPurple,
  },
  babyToddlerImmune: {
    low: babyToddlerImmuneLow,
    moderate: babyToddlerImmuneModerate,
    high: babyToddlerImmuneHigh,
    purple: babyToddlerImmunePurple,
  },
  childImmune: {
    low: childImmuneLow,
    moderate: childImmuneModerate,
    high: childImmuneHigh,
    purple: childImmunePurple,
  },
  adultImmune: {
    low: adultImmuneLow,
    moderate: adultImmuneModerate,
    high: adultImmuneHigh,
    purple: adultImmunePurple,
  },
  paediatricLungs: {
    low: paediatricLungsLow,
    moderate: paediatricLungsModerate,
    high: paediatricLungsHigh,
    purple: paediatricLungsPurple,
  },
  adultLungs: {
    low: adultLungsLow,
    moderate: adultLungsModerate,
    high: adultLungsHigh,
    purple: adultLungsPurple,
  },
  gut: {
    low: intestinesLow,
    moderate: intestinesModerate,
    high: intestinesHigh,
    purple: intestinesPurple,
  },
  gutFull: {
    low: intestinesFullLow,
    moderate: intestinesFullModerate,
    high: intestinesFullHigh,
    purple: intestinesFullPurple,
  },
  gutUterusFull: {
    low: intestinesUterusFullLow,
    moderate: intestinesUterusFullModerate,
    high: intestinesUterusFullHigh,
    purple: intestinesUterusFullPurple,
  },
  gutBabyFull: {
    low: intestinesBabyFullLow,
    moderate: intestinesBabyFullModerate,
    high: intestinesBabyFullHigh,
    purple: intestinesBabyFullPurple,
  },
  gutWithBaby: {
    low: intestinesWithBabyLow,
    moderate: intestinesWithBabyModerate,
    high: intestinesWithBabyHigh,
  },
  stomach: {
    low: stomachLow,
    moderate: stomachModerate,
    high: stomachHigh,
    purple: stomachPurple,
  },
  stomachFull: {
    low: stomachFullLow,
    moderate: stomachFullModerate,
    high: stomachFullHigh,
    purple: stomachFullPurple,
  },
  fetus: {
    low: fetusLow,
    moderate: fetusModerate,
    high: fetusHigh,
    purple: fetusPurple,
  },
  uterus: {
    low: uterusLow,
    moderate: uterusModerate,
    high: uterusHigh,
    purple: uterusPurple,
  },
};

/**
 * The design file's pre-composited intestines-and-uterus. Nothing consumes it: the
 * body layers `gut` and `reproductive` separately so each can show its own flag
 * level, and the uterus now has three states of its own. Dead unless the flattened
 * pair turns out to be wanted somewhere.
 */
export const GUT_WITH_UTERUS: GutBodyConnectionsArtwork = {
  low: intestinesWithUterusLow,
  moderate: intestinesWithUterusModerate,
  high: intestinesWithUterusHigh,
};
